import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validación deliberadamente permisiva: Cafler opera en ES, FR, UK y CL y cada
 * país tiene su formato. Se valida longitud y juego de caracteres, no un patrón
 * nacional concreto, para no bloquear matrículas legítimas.
 */
const LICENSE_PLATE_PATTERN = /^[A-Z0-9][A-Z0-9 -]{2,11}[A-Z0-9]$/;

export function normalizeLicensePlate(value: string): string {
  return value.trim().toUpperCase();
}

export function licensePlateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;

    if (typeof raw !== 'string' || raw.trim().length === 0) {
      return null; // La obligatoriedad la cubre Validators.required.
    }

    return LICENSE_PLATE_PATTERN.test(normalizeLicensePlate(raw))
      ? null
      : { licensePlate: true };
  };
}
